<template>
	<div>
		<div class="course-box1" v-if="Data.data && Data.data.length > 0">
			<div class="course-card cursor" :class="{ 'card-padding': isStatus == 1 }" @click="navTo(item_)"
				v-for="(item_, index_) in Data.data" :key="index_">
				<span class="status" v-if="isStatus == 1">未开始</span>
				<img :src="item_.main_drawing_pc ? item_.main_drawing_pc[0] : item_.main_drawing[0]" alt="">
				<div class="course-content">
					<div class="course-name fb fsm2 line2">{{ item_.title }}</div>
					<div class="course-pro fsm2">
						<div class="course-teacher line1 fsmain">
							<span class="name">{{ item_.lecturer.name }}</span> {{ item_.lecturer.brief_intro }}
						</div>
						<div class="course-join flex-space fsm-2" v-if="isLeft == 1">
							已有{{ item_.group_success_num }}人参与拼团
							<span class="link fsm2">去预约</span>
						</div>
						<div class="course-join flex-space fsm-2" v-else-if="isLeft == 2">
							{{ item_.viewers || 0 }}人看过
							<div v-if="item_.is_buy != 1">
								<span class="price fsm2"
									v-if="item_.viewing_restrictions == 'free' || item_.viewing_restrictions == 'appoint'">免费</span>
								<span class="price fsm2" v-else-if="item_.viewing_restrictions == 'pay'"><span
										class="fsm-2">￥</span>{{ item_.price || 0 }}</span>
								<span class="price fsm2" v-else-if="item_.viewing_restrictions == 'encryption'">加密</span>
							</div>
							<span class="price fsm2" v-else>已购买</span>
							<!-- <span class="price fsm2" v-else-if="item_.viewing_restrictions == 'appoint'">指定用户</span> -->
						</div>
						<div class="course-join flex-space fsm-2" v-else-if="isLeft == 3">
							{{ item_.viewers || 0 }}人看过
							<div v-if="item_.is_buy != 1">
								<span class="price fsm2"
									v-if="item_.viewing_restrictions == 'free' || item_.viewing_restrictions == 'appoint'">免费</span>
								<span class="price fsm2" v-else-if="item_.viewing_restrictions == 'pay'"><span
										class="fsm-2">￥</span>{{ item_.price || 0 }}</span>
								<span class="price fsm2" v-else-if="item_.viewing_restrictions == 'encryption'">加密</span>
							</div>
							<span class="price fsm2" v-else>已购买</span>
						</div>
						<div class="course-join flex-space fsm-2" v-else>
							<div v-if="item_.is_buy != 1">
								<span class="price fsm2"
									v-if="item_.viewing_restrictions == 'free' || item_.viewing_restrictions == 'appoint'">免费</span>
								<span class="price fsm2" v-else-if="item_.viewing_restrictions == 'pay'"><span
										class="fsm-2">￥</span>{{ item_.price || 0 }}</span>
								<span class="price fsm2" v-else-if="item_.viewing_restrictions == 'encryption'">加密</span>
							</div>
							<span class="price fsm2" v-else>已购买</span>
							<!-- <span class="price fsm2" v-else-if="item_.viewing_restrictions == 'appoint'">指定用户</span> -->
							{{ item_.viewers || 0 }}人看过
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-noData" v-else>
			<noData></noData>
		</div>
	</div>
</template>

<script>
import noData from '@/components/noData/index.vue'
export default {
	components: {
		noData
	},
	props: {
		isStatus: {
			type: Number, // 是否显示未开始 1显示  0不显示
			defult: 0// 默认不显示
		},
		isLeft: {
			type: Number, // 是否显示未开始 1显示  0不显示
			defult: 0// 默认显示已有800人参与拼团
		},
		Data: {
			type: Object,
			default: () => { return {} }
		},
		name: {
			type: String,
			default: ''
		}
	},
	data() {
		return {

		}
	},
	methods: {
		navTo(item) {
			if (this.name == 'kdjj' || this.name == 'zxkc' || this.name == 'xtlx') {
				this.$router.push('/details?id=' + item.id + '&propType=video' + '&title=' + this.name)
			} else {
				if (item.group_buy_price) {
					if (item.hasOwnProperty('video_list')) {
						this.$router.push('/details?id=' + item.id + '&propType=ptVideo' + '&title=' + this.name)
					} else if (item.live_state) {
						this.$router.push('/details?id=' + item.id + '&propType=ptLive' + '&title=' + this.name)
					}
				} else {
					if (item.hasOwnProperty('video_list')) {
						this.$router.push('/details?id=' + item.id + '&propType=video' + '&title=' + this.name)
					} else {
						this.$router.push('/details?id=' + item.id + '&propType=live' + '&title=' + this.name)
					}
				}
			}
		}
	}
}
</script>

<style scoped lang="less">
.course-box1 {
	display: flex;
	flex-wrap: wrap;

	.course-card {
		background: #FFFFFF;
		box-shadow: 0 0 12px rgba(187, 178, 178, 0.25);
		border-radius: 8px;
		width: 290px;
		margin-bottom: 20px;
		position: relative;
		margin-right: 13px;
		overflow: hidden;

		&:nth-of-type(4n) {
			margin-right: 0;
		}

		.status {
			width: 80px;
			height: 30px;
			background: #E5E5E5;
			border-radius: 8px 15px 15px 0px;
			position: absolute;
			top: 0;
			left: 0;
			text-align: center;
			line-height: 30px;
			color: #999999;
		}

		img {
			width: 290px;
			height: 180px;
		}

		.course-content {
			padding: 10px 10px 15px;

			.course-name {
				margin-bottom: 5px;
				height: 48px;
				line-height: 1.25;
			}

			.course-pro {
				color: #666;

				.course-teacher {
					margin-bottom: 16px;

					.name {
						position: relative;
						margin-right: 16px;

						&:after {
							content: '';
							display: block;
							position: absolute;
							top: 3px;
							width: 1px;
							height: 18px;
							background-color: #999;
							right: -12px;
						}
					}
				}

				.course-join {
					.price {
						color: #F26F2A;
						font-weight: bold;
					}

					.link {
						width: 90px;
						height: 34px;
						background: linear-gradient(87deg, #FD9A3D, #F3702A);
						border-radius: 17px;
						text-align: center;
						line-height: 34px;
						color: #fff;
					}
				}
			}
		}
	}

	.card-padding {
		padding: 50px 20px 20px;
	}
}</style>



// WEBPACK FOOTER //
// src/components/Course/group.vue